{
  "eyebrow": "Потвърдете плана",
  "title": "Прегледайте и конфигурирайте.",
  "sub": "Можете да промените цикъла на фактуриране или плана по всяко време от админ панела.",
  "yourPlan": "Вашият план",
  "changePlan": "Промени плана",
  "billing": "Цикъл на фактуриране",
  "billingMonthLabel": "Плащане месечно",
  "billingMonthDesc": "Гъвкаво. Отказ по всяко време.",
  "billingYearLabel": "Плащане годишно",
  "billingYearDesc": "15% отстъпка. Фактурира се веднъж годишно.",
  "addons": "Добавки",
  "addon": {
    "ssec": "Социална осигуровка (check-in/out@work)",
    "ssecDesc": "Само Белгия — автоматична декларация Dimona.",
    "vtt": "Vehicle Track & Trace",
    "vttDesc": "GPS в реално време за служебни автомобили. +4 €/превозно средство/месец.",
    "vehicles": "Превозни средства"
  },
  "employees": {
    "title": "Колко служители?",
    "active": "потребители",
    "popular": "Повечето екипи избират {{n}}"
  },
  "estimate": "Прогнозна месечна цена",
  "estimateNote": "Без ДДС. Плащате за броя потребители, зададен тук, и можете да го промените по-късно.",
  "estimateUnavailable": "Каталогът с цени е недостъпен. Опитайте отново, за да заредите най-новите цени."
}
